var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn"},[_c('b-tabs',{attrs:{"card":""}},[_c('b-tab',{attrs:{"title":"Instruments","active":""}},[_c('h3',[_vm._v("Instruments")]),_c('instrument-server-table',{attrs:{"show_columns":['name', 'description']}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }